








import { Component, Vue } from 'vue-property-decorator'
import { env } from '@ivy/fts/envInfo/envInfo'

@Component({})
export default class OrderPay extends Vue {
  urlpic: any = ''
  async created() {
    await env.init()
    let { data } = await this.$axios.get(
      '/api/mobile/adv/privateFlowQRCode/qRCodeByGMV'
    )
    this.urlpic = data
  }
}
